// Loading placeholder for the search page. Mirrors the real layout — the
// search input (h-12 rounded-xl, see SearchInput) plus the Telegram-style
// grouped category card (see CategoryList) — so the page doesn't shift when
// the categories arrive.
const ROW_WIDTHS = ["w-32", "w-40", "w-24", "w-36", "w-28", "w-44", "w-32", "w-28"];

export default function SearchSkeleton() {
  return (
    <div className="w-full">
      <section className="p-4">
        <div className="h-12 w-full rounded-xl bg-content4 animate-pulse" />
      </section>

      <div className="mx-3 mt-3 overflow-hidden rounded-2xl bg-background">
        {ROW_WIDTHS.map((width, i) => (
          <div key={i}>
            {i > 0 ? <div className="h-px bg-content3 mr-[3.75rem]" /> : null}
            <div className="flex items-center gap-3 px-4 py-3">
              <div className="size-8 shrink-0 rounded-[10px] bg-content4 animate-pulse" />
              <div className={`h-3 rounded bg-content4 animate-pulse ${width}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
